import * as Api from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { ITemplateCard } from '../../../../viewmodels/AppViewModels';
import { TemplateDateField } from '../TemplateDateField';
import { styleSheet } from './styles';

interface ITemplateDateFieldsProps {
	template: ITemplateCard;
	templateType: Api.TemplateType;
	onSuccess?: () => void;
	styles?: StyleDeclarationValue[];
}

export const TemplateDateFields: React.FC<ITemplateDateFieldsProps> = ({
	template,
	templateType,
	onSuccess,
	styles: customStyles = [],
}) => {
	return (
		<div className={css(styleSheet.container, ...customStyles)}>
			<TemplateDateField
				template={template}
				templateType={templateType}
				fieldName='startDate'
				label='Suggested Use Date'
				onSuccess={onSuccess}
			/>
			<TemplateDateField
				template={template}
				templateType={templateType}
				fieldName='expirationDate'
				label='Expiration Date'
				onSuccess={onSuccess}
			/>
		</div>
	);
};
